
export const CHANGE_USER = 'CHANGE_USER';

export interface ChangeSecurityUser {
    type: typeof CHANGE_USER,
    payload: ISecurityState
}

export interface ISecurityState {
    token: string,
    user: string,
    email: string
}

/**
 * Change 
 */
export function changeUser(payload: ISecurityState): ChangeSecurityUser {
    console.log('changeUser', payload);
    return { type: CHANGE_USER, payload };
}

export const selectUser = (state: ISecurityState) => state.token;
